import { render } from "./DisciplinaryManagement.vue?vue&type=template&id=4bc2284d&scoped=true"
import script from "./DisciplinaryManagement.vue?vue&type=script&lang=js"
export * from "./DisciplinaryManagement.vue?vue&type=script&lang=js"

import "./DisciplinaryManagement.vue?vue&type=style&index=0&id=4bc2284d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc2284d"]])

export default __exports__